import React, { useEffect } from 'react';
import { useMetadata } from '../contexts/MetadataContext';

function PageTitle({ page, suffix = true }) {
  const metadata = useMetadata();
  
  // Construct the title based on the page and metadata
  const title = page 
    ? `${page} | ${metadata.title}` 
    : metadata.title;
  
  useEffect(() => {
    // Update the document title when the component mounts or title changes
    document.title = title;
    
    // Optional: Update Open Graph and Twitter title tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    const twitterTitle = document.querySelector('meta[property="twitter:title"]');
    
    if (ogTitle) ogTitle.setAttribute('content', title);
    if (twitterTitle) twitterTitle.setAttribute('content', title);
    
    return () => {
      // Reset to default title on unmount
      document.title = metadata.title;
    };
  }, [title, metadata.title]);
  
  // This component doesn't render anything visible
  return null;
}

export default PageTitle;
